import z from "zod";

const gmailErrorTypeValues = [
  "MISSING_IMPERSONATED_USER_EMAIL",
  "OAUTH_CLIENT_TYPE_MISMATCH",
  "OAUTH_AUTHENTICATION_FAILED",
  "EMAIL_MISSING_FIELD",
  "EMAIL_TOO_LARGE",
] as const;

const gmailErrorTypeSchema = z.enum(gmailErrorTypeValues);
export const GmailErrorType = gmailErrorTypeSchema.enum;
export type GmailErrorType = z.infer<typeof gmailErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type GmailErrors =
  | {
      errorType: typeof GmailErrorType.MISSING_IMPERSONATED_USER_EMAIL;
      data: undefined;
    }
  | {
      errorType: typeof GmailErrorType.OAUTH_CLIENT_TYPE_MISMATCH;
      data: {
        impersonatedUserEmail: string;
        clientType: string;
      };
    }
  | {
      errorType: typeof GmailErrorType.OAUTH_AUTHENTICATION_FAILED;
      data: {
        impersonatedUserEmail: string;
        reason: string;
        originalError?: string;
        retriesAttempted?: number;
        timeoutMs?: number;
      };
    }
  | {
      errorType: typeof GmailErrorType.EMAIL_MISSING_FIELD;
      data:
        | {
            missingField: "ID";
          }
        | { missingField: "THREAD_ID"; emailId?: string | null }
        | { missingField: "FROM"; emailId?: string | null }
        | { missingField: "RAW_DATA"; emailId?: string | null };
    }
  | {
      errorType: typeof GmailErrorType.EMAIL_TOO_LARGE;
      data: {
        messageId: string;
        sizeEstimate: number;
        maxSizeBytes: number;
      };
    };

export const gmailErrorDetails: Record<GmailErrorType, ErrorDetails> = {
  MISSING_IMPERSONATED_USER_EMAIL: {
    sentryDescription: "Impersonated user email must be provided for Gmail client creation",
  },
  OAUTH_CLIENT_TYPE_MISMATCH: {
    sentryDescription: "Expected OAuth2Client for Gmail API authentication",
  },
  OAUTH_AUTHENTICATION_FAILED: {
    sentryDescription: "Gmail OAuth2 authentication failed after retries",
  },
  EMAIL_MISSING_FIELD: {
    sentryDescription: "Message ID required for Gmail email operation",
  },
  EMAIL_TOO_LARGE: {
    sentryDescription: "Gmail email size exceeds maximum limit",
  },
};
